import { create } from "zustand"

export type LoadingStoreType = {
    loading: boolean
    setLoading: (loading: boolean) => void
}

const useLoadingStore = create<LoadingStoreType>()(
    (set) => ({
        loading: false,
        setLoading: (loading) => set({ loading })
    }),
)

export default useLoadingStore
